import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CARDINALITY_TYPES } from '../../constants/associations';
import { NextIcon } from 'foundations-assets/icons/components/NextIcon';
import { ObjectAssociationsIcon } from 'foundations-assets/icons/components/ObjectAssociationsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const CardinalityIcon = ({
  cardinality
}) => {
  if (cardinality === CARDINALITY_TYPES.ONE_TO_ONE) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.create.cardinalityIcon.oneToOne"
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        paddingInline: "200",
        as: "span",
        children: /*#__PURE__*/_jsx(NextIcon, {
          color: "icon-tertiary-default",
          size: "300"
        })
      })
    });
  }
  if (cardinality === CARDINALITY_TYPES.ONE_TO_MANY) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.create.cardinalityIcon.oneToMany"
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        paddingInline: "200",
        as: "span",
        children: /*#__PURE__*/_jsx(ObjectAssociationsIcon, {
          color: "icon-tertiary-default",
          size: "300"
        })
      })
    });
  }
  return null;
};
export default CardinalityIcon;